import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserProfile, saveUserProfile } from '../../api/user';
import ActiveUserSubscriptions from '../../components/subscriptions/activeUserSubscriptions';
import { countries } from '../../constants/countries.js';

export default function Profile() {
  const navigate = useNavigate();

  const defaultProfile = {
    userId: 0,
    firstName: '',
    lastName: '',
    email: '',
    oldAddressId: '',
    country: '',
    zip: '',
    city: '',
    street: '',
    phone1: '',
    phone2: '',
    bankAccountNr: '',
    comment: '',
    taxInvoice: false,
    companyName: '',
    taxNumber: '',
    taxZip: '',
    taxCity: '',
    taxStreet: '',
  };

  const [formData, setFormData] = useState(defaultProfile);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProfile() {
      try {
        const response = await getUserProfile();
        if (response) {
          setFormData(response.Profile);
        }
      } catch (error) {
        console.error('Hiba a profil betöltésekor:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await saveUserProfile(formData);
      alert('Sikeres módosítás');
      navigate('/home');
    } catch (error) {
      console.error('Hiba a mentéskor:', error);
    }
  };

  if (loading) {
    return <Typography>Adatok betöltése...</Typography>;
  }

  return (
    <Box p={3} display='flex' flexDirection='column' alignItems='center'>
      <Typography variant='h4' mb={2}>
        Profilom
      </Typography>

      <Paper sx={{ padding: 3, width: '100%', maxWidth: 1200 }}>
        <Typography variant='h6' mb={2}>
          Személyes adatok
        </Typography>

        {/* Személyes adatok - Stack helyett Grid */}
        <Stack spacing={2}>
          <Box display='flex' gap={2}>
            <TextField
              label='Vezetéknév'
              name='lastName'
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              label='Keresztnév'
              name='firstName'
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
            />
          </Box>

          <Box display='flex' gap={2}>
            <TextField
              label='E-Mail cím'
              name='email'
              value={formData.email}
              onChange={handleChange}
              fullWidth
              disabled
            />
            <TextField
              label='Telefonszám 1'
              name='phone1'
              value={formData.phone1}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label='Telefonszám 2'
              name='phone2'
              value={formData.phone2}
              onChange={handleChange}
              fullWidth
            />
          </Box>

          <TextField
            label='Bemutatkozás'
            name='comment'
            value={formData.comment}
            onChange={handleChange}
            fullWidth
            multiline
            rows={4}
            variant='filled'
            sx={{ width: '100%', height: '100%' }}
          />
        </Stack>

        {/* Cím adatok */}
        <Typography variant='h6' mt={3} mb={2}>
          Cím adatok
        </Typography>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <InputLabel>Ország</InputLabel>
            <Select
              name='country'
              value={formData.country}
              onChange={handleChange}
            >
              {countries.map((c) => (
                <MenuItem key={c.id} value={c.id}>
                  {c.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box display='flex' gap={2}>
            <TextField
              label='Irányítószám'
              name='zip'
              value={formData.zip}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label='Város'
              name='city'
              value={formData.city}
              onChange={handleChange}
              fullWidth
            />
          </Box>

          <TextField
            label='Cím'
            name='street'
            value={formData.street}
            onChange={handleChange}
            fullWidth
          />
        </Stack>
        {/*
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.taxInvoice}
              onChange={handleCheckboxChange}
              name='taxInvoice'
            />
          }
          label='Cég nevére kérem a számlát'
        />

        Céges adatok csak ha szükséges */}
        {/*formData.taxInvoice && (
          <>
            <Typography variant='h6' mt={3} mb={2}>
              Céges számlázási adatok
            </Typography>
            <Stack spacing={2}>
              <TextField
                label='Cég neve'
                name='companyName'
                value={formData.companyName}
                onChange={handleChange}
                fullWidth
                required={formData.taxInvoice}
              />

              <Box display='flex' gap={2}>
                <TextField
                  label='Adószám'
                  name='taxNumber'
                  value={formData.taxNumber}
                  onChange={handleChange}
                  fullWidth
                  required={formData.taxInvoice}
                />
                <TextField
                  label='Irányítószám'
                  name='taxZip'
                  value={formData.taxZip}
                  onChange={handleChange}
                  fullWidth
                />
              </Box>

              <Box display='flex' gap={2}>
                <TextField
                  label='Város'
                  name='taxCity'
                  value={formData.taxCity}
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  label='Cím'
                  name='taxStreet'
                  value={formData.taxStreet}
                  onChange={handleChange}
                  fullWidth
                />
              </Box>
            </Stack>
          </>
        )*/}

        <Button
          variant='contained'
          color='primary'
          sx={{ mt: 3 }}
          onClick={handleSave}
        >
          Adatok frissítése
        </Button>
      </Paper>

      <ActiveUserSubscriptions userId={formData.userId} />
    </Box>
  );
}
